import { FormOption } from '@forms';
import { CurrencyCode, formatCurrency, LocaleId } from '@i18n';
import { PriceBand } from '../models/price-band.interface';

export function formatPriceBandOptions(
  priceBands: PriceBand[],
  currencyCode: CurrencyCode,
  localeId: LocaleId,
): FormOption[] {
  return priceBands.map(({ value }, index) => {
    const previousPriceBand = priceBands[index - 1]?.value;
    const min = formatCurrency(
      previousPriceBand ? previousPriceBand + 1 : 0,
      currencyCode,
      localeId,
      '1.0-2',
    );
    const max = formatCurrency(value, currencyCode, localeId, '1.0-2');
    return {
      label: `${min} - ${max}`,
      value,
    };
  });
}
